import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import * as RidersSelectors from '../../../../../store/selectors/riders.selectors';
import * as  RidersActions from '../../../../../store/actions/riders.actions';
import { Rider } from '../../../../../commons/models/riders';
import { Observable } from 'rxjs';
import { takeUntil, map } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Order } from '../../../../../commons/models/order';

@Component({
  selector: 'app-riders-dialog',
  templateUrl: './riders-dialog.component.html',
  styleUrls: ['./riders-dialog.component.scss']
})
export class RidersDialogComponent implements OnInit {
  riders$: Observable<Rider[]>;
  selectedRider: Rider | null = null;
  displayedColumns: string[] = ['name', 'surname', 'phone', 'email'];
  private unsubscribe$ = new Subject<void>();

  constructor(
    public dialogRef: MatDialogRef<RidersDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {order: Order},
    private store$: Store,
  ) {}

  ngOnInit() {
    this.riders$ = this.store$.select(RidersSelectors.getRiders).pipe(
      takeUntil(this.unsubscribe$),
      map((dtos) => dtos ? dtos.map(dto => new Rider(dto)) : [])
    );

    this.store$.dispatch(RidersActions.loadRiders({
      page: 1,
      perPage: 10, 
      filters: {}
    }));
  }

  onSelect(rider: Rider): void {
    this.selectedRider = rider;
  }

  confirmSelection(): void {
    if (this.selectedRider) {
      this.dialogRef.close({order: this.data.order, rider: this.selectedRider });
    }
  }

  onClose(): void {
    this.dialogRef.close(this.selectedRider);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
